import { IPromoItems } from "web/types/Gtm";

const gtmGetItemPromo = (itemId = "") => {
  const dataLayerTemp = window.dataLayer ? [...window.dataLayer].reverse() : [];

  const promoItems: IPromoItems =  {};
  for (let i = 0; i <= dataLayerTemp.length; i += 1) {
    if (dataLayerTemp[i]?.event === "detailImpression") {
      const { id, creative_slot, promotion_name } = dataLayerTemp[i]?.ecommerce?.detail?.products?.[0] || {};
      if (itemId === id) {
        return { creative_slot, promotion_name };
      }
      if (id) {
        promoItems[id] = { creative_slot, promotion_name };
      }
    }
  }

  return promoItems;
};

export default gtmGetItemPromo;